$(function () {
    $(".ar-landing-carousel-block__slides-container").slick({
        arrows: false,
        centerMode: true,
        centerPadding: '0',
        //autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    variableWidth: false,
                    dots: true
                }
            }
        ]
    });

    $(".ar-landing-carousel-block")
        .on("click", ".landing-carousel-block-slide__next", function (e) {
            e.preventDefault();
            $(this).closest(".ar-landing-carousel-block__slides-container").slick("slickNext");
        })
        .on("click", ".landing-carousel-block-slide__previous", function (e) {
            e.preventDefault();
            $(this).closest(".ar-landing-carousel-block__slides-container").slick("slickPrev");
        })
        .on("mouseenter", ".landing-carousel-block-slide__link", function (e) {
            var targetImageId = $(this).data("image-id");

            if (targetImageId) {
                $(".landing-carousel-block-slide__image-container_hide-mobile .landing-carousel-block-slide__image", $(this).closest(".landing-carousel-block-slide__container")).each(function (index, element) {
                    var $element = $(element);
                    var imageId = $element.data("image-id");

                    if (imageId === targetImageId) {
                        $element.css("opacity", 1);
                    }
                    else {
                        $element.css("opacity", 0);
                    }
                });
            }
        })
        .on("mouseleave", ".landing-carousel-block-slide__link", function (e) {
            $(".landing-carousel-block-slide__image-container_hide-mobile .landing-carousel-block-slide__image", $(this).closest(".landing-carousel-block-slide__container")).each(function (index, element) {
                var $element = $(element);
                var imageId = $element.data("image-id");

                if (imageId === "default") {
                    $element.css("opacity", 1);
                }
                else {
                    $element.css("opacity", 0);
                }
            });
        });
        //.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        //    $(slick.$slides[currentSlide]).find(".landing-carousel-block-slide__container").fadeOut();
        //    $(slick.$slides[nextSlide]).find(".landing-carousel-block-slide__container").fadeIn();
        //});
});